import { getAuth } from "firebase/auth";
import { getAuthCentral } from "../../config/FirebaseConfig";
import { getFirestore, doc, getDoc } from "firebase/firestore";
import { checkDB } from "../../models/DataFunctions.js";
import addLogDocument from "../addLogDocument.js";
import { fileOpen } from "browser-fs-access"; // Replacing FilePicker

const uploadImage = async (oid, token, prefix) => {
  try {
    // Open file dialog for selecting a single image file
    const files = await fileOpen({
      description: "Select an image",
      mimeTypes: ["image/*"],
      multiple: false, // Only one file
    });

    if (files) {
      const file = files; // Since multiple: false, this will be a single file object
      const fileBytes = await file.arrayBuffer(); // Read file as bytes

      const url = prefix + "upload/logo";
      const fileName = file.name.replaceAll(" ", "_");

      if (fileBytes) {
        const formData = new FormData();

        // Append the file and other fields to the request body
        formData.append("file", new Blob([fileBytes]), fileName);
        formData.append("oid", oid);

        const headers = {
          Authorization: `Bearer ${token}`,
        };
        let start = new Date();
        // Send the POST request
        const response = await fetch(url, {
          method: "POST",
          headers: headers,
          body: formData,
        });

        const auth = getAuthCentral();
        const currentUser = auth.currentUser;
        if (!currentUser) {
          console.error("User not logged in");
          return;
        }

        const db = getFirestore();
        const userRef = doc(db, "user", currentUser.uid);
        const userSnapshot = await getDoc(checkDB(userRef));

        if (!userSnapshot.exists()) {
          console.error("User document not found");
          return;
        }

        const org_id = userSnapshot.get("org_id");
        let end = new Date();
        let elapsed = end - start;
        // Add log document
        await addLogDocument(
          url,
          prefix,
          userRef, // Log the userRef ID
          org_id,
          response.status.toString(),
          "", // folderid
          "", // docid
          formData.toString(), // request body as string
          await response.text(),
          "POST",
          elapsed
        );

        // Check response status
        if (response.ok) {
        } else {
          console.error(`Error response: ${response.status}`);
        }
      } else {
      }
    }
  } catch (error) {
    console.error("Error selecting/uploading file:", error);
  }
};

export default uploadImage;
